var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          ref: "popver-notification",
          attrs: { placement: "bottom", trigger: "click" },
          on: { show: _vm.onOpen },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "nav-downloads-wrapper",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c(
                "el-badge",
                {
                  staticClass: "bell-num",
                  attrs: {
                    value: _vm.$store.getters.unreadNotificaionCount,
                    hidden: _vm.$store.getters.unreadNotificaionCount === 0,
                  },
                },
                [
                  _c("i", {
                    staticClass: " el-icon-bell",
                    staticStyle: {
                      "font-weight": "bolder",
                      "font-size": "18px",
                      color: "#4b5567",
                    },
                  }),
                ]
              ),
              _c("i", { staticClass: "el-icon-caret-bottom icon-arrow-down" }),
            ],
            1
          ),
          _vm.loading
            ? _c("div", { staticClass: "loading-container" }, [
                _c("i", { staticClass: "el-icon-loading" }),
              ])
            : _vm.list.length <= 0
            ? _c("div", { staticClass: "empty-container" }, [
                _c("div", { staticClass: "empty-content" }, [
                  _c("img", {
                    staticStyle: { width: "50px" },
                    attrs: {
                      src: require("@/assets/img/notification_empty.png"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "empty-tip" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("no_auth.no_notification")) + " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "view-more ",
                    on: { click: _vm.onClickViewMoreTxt },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("no_auth.view_all")) + " ")]
                ),
              ])
            : [
                _c(
                  "div",
                  { staticClass: "nav-notification-list" },
                  _vm._l(_vm.list, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.user_detail_no,
                        staticClass: "nav-notification-item",
                        class: {
                          "padding-top-0": index === 0,
                          "padding-bottom-0": index === _vm.list.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickNotificatonItem(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "nav-notification-icon-container" },
                          [
                            _c(
                              "el-badge",
                              {
                                attrs: {
                                  "is-dot": item.user_read_status === 1,
                                },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                  },
                                  attrs: {
                                    src: require("@/assets/img/message_time.png"),
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", [
                          _c("div", { staticClass: "nav-notification-name" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "nav-notification-status" },
                            [
                              _c("span", { staticClass: "limit-length" }, [
                                _vm._v(_vm._s(item.user_detail_no)),
                              ]),
                            ]
                          ),
                        ]),
                        item.notice_actual_time
                          ? _c(
                              "div",
                              { staticClass: "nav-notification-time" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.notice_actual_time.split(" ")[0]
                                    )
                                  ),
                                ]),
                                _c("br"),
                                _c(
                                  "span",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.notice_actual_time.split(" ")[1]
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "view-more ",
                    on: { click: _vm.onClickViewMoreTxt },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("no_auth.view_all")) + " ")]
                ),
              ],
        ],
        2
      ),
      _c("Notification", { ref: "notification" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }